module.exports = __webpack_public_path__ + "img/ic-close-circle.4e1f4a4a.svg";